export const competitorData = [
  { platform: 'HoobuySpreadsheet', velocidade: 'Alta', organizacao: 'Excelente', seguranca: 'Alta', atualizacao: 'Diária' },
  { platform: 'PandaBuy Spreadsheet', velocidade: 'Média', organizacao: 'Boa', seguranca: 'Média', atualizacao: 'Semanal' },
  { platform: 'Yupoo', velocidade: 'Baixa', organizacao: 'Ruim', seguranca: 'Baixa', atualizacao: 'Irregular' },
  { platform: 'SugarGOO Spreadsheet', velocidade: 'Média', organizacao: 'Regular', seguranca: 'Média', atualizacao: 'Quinzenal' },
];